import React from 'react';

const UserSvg = () => (
  <>
    <object
      className="user-menu__icon"
      data="/static/img/user.svg"
      alt="User menu"
      type="image/svg+xml"
    />
    <object
      className="user-menu__icon user-menu__icon--hover"
      data="/static/img/user-hover.svg"
      alt="User menu"
      type="image/svg+xml"
    />
  </>
);

export default UserSvg;
